// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'warn';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 14.316a.284.284 0 0 1 0-.566m0 .566a.284.284 0 0 0 0-.566M9 11V6' />
    <path d='M10.224 1.263a1.364 1.364 0 0 0-2.449 0L.618 15.842a1.149 1.149 0 0 0 1.033 1.656h14.698a1.148 1.148 0 0 0 1.033-1.656z' />
  </g>
);

export const viewBox = '0 0 18 18';
